import React from 'react';

type PillSize = 'sm' | 'md' | 'lg';

interface Props {
  children: React.ReactNode;
  bg?: string;
  fg?: string;
  size?: PillSize;
  className?: string;
}

const SIZES: Record<PillSize, { padding: string; fontSize: number }> = {
  sm: { padding: '3px 8px', fontSize: 10 },
  md: { padding: '4px 10px', fontSize: 11 },
  lg: { padding: '6px 12px', fontSize: 12 },
};

export function Pill({ children, bg = '#F2B90C', fg = '#0B3F12', size = 'md', className }: Props) {
  const s = SIZES[size];
  return (
    <span
      className={['inline-block whitespace-nowrap font-bold tracking-wider', className || ''].join(' ').trim()}
      style={{
        background: bg,
        color: fg,
        borderRadius: 999,
        padding: s.padding,
        fontSize: s.fontSize,
        letterSpacing: '0.04em',
      }}
    >
      {children}
    </span>
  );
}
